import FaqLayout from "@/components/feature/FaqLayout";

export default function UnrecognizedChargePage() {
  return (
    <FaqLayout
      breadcrumb="/ Billing & Payments"
      title="I don't recognize this"
      accent="charge"
    >
      <div className="space-y-6 text-[#1A1C1E]">
        <h2 className="text-2xl font-bold text-[#1A1C1E]">Identifying and Resolving Unrecognized Charges</h2>
        <p className="text-[15px] leading-relaxed text-[#4B5563]">
          If you see a charge from Trevionix that you do not recognize, there are several steps you should take before filing a formal dispute. In most cases, the charge is legitimate and simply unfamiliar due to how it appears on your statement.
        </p>

        <h3 className="text-lg font-semibold text-[#1A1C1E] mt-8">How Trevionix Charges Appear</h3>
        <p className="text-[15px] leading-relaxed text-[#4B5563]">
          Depending on your bank and card issuer, Trevionix charges may appear under any of the following names on your statement:
        </p>
        <ul className="list-disc list-inside space-y-3 text-[15px] leading-relaxed text-[#4B5563] mt-3">
          <li>TREVIONIX LTD</li>
          <li>TREVIONIX*HELP</li>
          <li>LNDNAPP.COM</li>
          <li>TREVIONIX — LONDON</li>
        </ul>

        <h3 className="text-lg font-semibold text-[#1A1C1E] mt-8">Steps to Verify the Charge</h3>
        <ol className="list-decimal list-inside space-y-3 text-[15px] leading-relaxed text-[#4B5563]">
          <li>Check your Trevionix account <strong>Billing History</strong> to match the date and amount.</li>
          <li>Ask family members or colleagues who may have access to your card if they made the purchase.</li>
          <li>Review your email for order confirmations around the charge date.</li>
          <li>Check if the charge corresponds to a subscription renewal you may have forgotten about.</li>
        </ol>

        <h3 className="text-lg font-semibold text-[#1A1C1E] mt-8">If the Charge Is Still Unrecognized</h3>
        <p className="text-[15px] leading-relaxed text-[#4B5563]">
          If you have verified the charge is not yours, you can file a formal dispute resolution request. Our team will investigate the transaction within 3 to 5 business days and may issue a refund if the charge is confirmed to be unauthorized.
        </p>

        <div className="bg-[#F7F5F2] rounded-xl p-6 mt-8">
          <p className="text-sm font-semibold text-[#1A1C1E] mb-2">Protect your account</p>
          <p className="text-sm text-[#6C7278]">
            If you suspect your account has been compromised, change your password immediately and enable two-factor authentication in your account settings.
          </p>
        </div>
      </div>
    </FaqLayout>
  );
}